import Table from '@/components/Table/Table.jsx'
import {useMapContext} from '@/components/MindMap/index.mjs'
import TableChooseDesign from '../../nodes/_DESIGN/TableChooseDesign.jsx'

const ViewCode = ({map, value}) => {
    const {codeProp} = map.BizNode[value.bizNodeType]
    const code = value[codeProp]
    return <Table.ViewText value={code} />
}

const ViewText = ({map, value}) => {
    const {textProp} = map.BizNode[value.bizNodeType]
    const text = value[textProp]
    return <Table.ViewText value={text} />
}

const ViewType = ({map, value}) => {
    const typeName = map.BizNode[value].typeName(map)
    return <Table.ViewText value={typeName} />
}

export default function TableChooseProducts(props) {
    const map = useMapContext()

    const columns = [
        {
            title: '制品类型',
            dataIndex: 'bizNodeType',
            component: <ViewType map={map} />,
        },

        {
            title: '制品代码',
            dataIndex: 'code',
            getValue: row => row,
            component: <ViewCode map={map} />,
        },

        {
            title: '制品名称',
            dataIndex: 'name',
            getValue: row => row,
            component: <ViewText map={map} />,
        },

        {
            title: '制品状态',
            dataIndex: 'stsName',
            component: <Table.ViewText />,
        },

        {
            title: '更新人',
            dataIndex: 'uptName',
            component: <Table.ViewText />,
        },

        {
            title: '更新时间',
            dataIndex: 'uptTime',
            component: <Table.ViewText />,
        },
    ]

    return (
        <TableChooseDesign
            columns={columns}
            {...props}
        />
    )
}
